import React from "react";
import "./footer.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
    <section className="section_footer">
      <img src="\assets\footerbg.png" className="imgfooter"/>
       <div className='custom-container'>
   <div className="footer_side">
        <img src="\assets\footerlogo.svg" />
        <h3>Copyright © 2025 GEMS. All Rights Reserved.</h3>
      </div>
       </div>
    </section>

    </>
  );
};

export default Footer;
